import { render, staticRenderFns } from "./Soundboard.vue?vue&type=template&id=5046ce8f&"
import script from "./Soundboard.vue?vue&type=script&lang=ts&"
export * from "./Soundboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports